<template>
   
        
</template>

<script>
export default {
  data: () => ({}),
  mounted: function() {
    this.$nextTick(function() {});
  },
  methods: {}
};
</script>
<style scoped>
.rangeDate .flex {
  padding: 0 !important;
}
.active {
  background-color: rgb(0, 150, 136) !important;
}
</style>


// WEBPACK FOOTER //
// src/components/dataTable/commonTable/actionsHeader/btnFiltrar/BtnFiltrar.vue